import React from 'react'
const IconDelete = () => {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g transform='scale(0.97)'>
        <path
          d='M14.3927 4.49992H18.976V6.33325H17.1427V18.2499C17.1427 18.493 17.0461 18.7262 16.8742 18.8981C16.7023 19.07 16.4691 19.1666 16.226 19.1666H3.3927C3.14958 19.1666 2.91643 19.07 2.74452 18.8981C2.57261 18.7262 2.47603 18.493 2.47603 18.2499V6.33325H0.6427V4.49992H5.22603V1.74992C5.22603 1.5068 5.32261 1.27365 5.49452 1.10174C5.66643 0.929829 5.89958 0.833252 6.1427 0.833252H13.476C13.7191 0.833252 13.9523 0.929829 14.1242 1.10174C14.2961 1.27365 14.3927 1.5068 14.3927 1.74992V4.49992ZM15.3094 6.33325H4.30937V17.3332H15.3094V6.33325ZM7.05937 9.08325H8.8927V14.5833H7.05937V9.08325ZM10.726 9.08325H12.5594V14.5833H10.726V9.08325ZM7.05937 2.66658V4.49992H12.5594V2.66658H7.05937Z'
          fill='black'
          stroke='#F4F6FD'
          strokeWidth='0.628572'
        />
      </g>
    </svg>
  )
}
export default IconDelete
